<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <div class="attr-json"
            v-wjTooltip="attr.tooltip"
            v-wjContextMenu="'ContextWidgetMenuId'"
        >
            <label class="label-attr" v-if="attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</label>

            <div class="grid-top-line json-top-line" ref="attr_top_line" v-if="!attr?.hideCommandPanel">
                <div class="commandPanel-area" ref="commandPanelArea"
                    :style="commandPanelAreaWidth != null ? { flex: '0 1 ' + commandPanelAreaWidth + 'px' } : (!commandPanel.length && !commandPanelOverflow.length ? { flex: '0 0 0', minWidth: '0', overflow: 'hidden' } : {})"
                >
                    <div class="commandPanel-menu" v-if="commandPanel.length && commandPanelMaxVisible !== 0" ref="commandPanelMenu"
                        :style="commandPanelMenuWidth != null ? { flex: '0 0 ' + commandPanelMenuWidth + 'px' } : {}"
                    >
                        <span v-for="(attrM, index) in commandPanel"
                            :key="attrM.html_id"
                            class="cp-item-wrap"
                            v-show="index < commandPanelMaxVisible"
                        >
                            <component
                                :widget_id="widget_id"
                                :is="attrM.component"
                                :attr_id="attrM.id"
                                :initialAttr="attrM"
                            />
                        </span>
                    </div>
                    <div class="widget_menu commandPanel-overflow-btn" v-if="commandPanelOverflow.length">
                        <wj-menu
                            class="commandPanel-overflow-menu"
                            :header="''"
                            :displayMemberPath="'titleAction'"
                            :subItemsPath="'attrs'"
                            :showDropDownButton="false"
                            :openOnHover="true"
                            :isAnimated="false"
                            :itemsSource="commandPanelOverflow"
                            :itemClicked="menuNodeClicked"
                            :formatItem="store.formatMenuItem"
                        >
                            <i class="pi pi-ellipsis-v"></i>
                        </wj-menu>
                    </div>
                </div>

                <div class="grid-chips" v-if="!attr?.hideCHIPS && !attr?.dropdown">
                    <AttrChips ref="chips" :widget_id="widget_id" :attr_id="attr_id" :modelValue="chips_list" @update:modelValue="onChipsUpdate" @chip-search-nav="onChipSearchNav" :mode="'Legacy'" />
                </div>

<!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div v-if="isError" class="json-error">
                    ⚠️ {{ t('Error converting text to JSON') }}
                </div>

                <!-- IE 2026 09 28 / ODOO-342342 (заказ Игоря: «"меню" — прижато вправо и форма меню как у ≡ таблицы»): ≡ поля — панель функций MenuPanel (те же пункты actionMenu:
                     Command panel, Fold, JS deep — группами колонками, поиск, избранное), у правого края строки; прежний wj-menu — флаг fe.ux.menuPanelEverywhere
                     выключен / мобильный профиль (utils/menuPanelHost.js) -->
                <div class="widget_menu mr-2" :class="{ 'menu-push-right': menuPanelHost_on() }">
                    <MenuPanel v-if="actionMenu.length && !attr?.dropdown && menuPanelHost_on()" :items="actionMenu" align="right" :caret="false" btnClass="widget-menu-btn field-menu-btn"
                        :title="t('Field menu')" titleIcon="pi pi-bars" :subtitle="menuPanelSubtitle()" :openDelay="200" :runsTitle="t('Field')" search :searchPlaceholder="t('Search commands…')"
                        :favKey="menuFavKind()" :favOf="menuFavOf" :epoch="store._favEpoch" :favTitle="t('Favourite command')" help="field" :btnShort="t('Field menu')"
                        @pick="menuPanelPick" @fav="menuFav">
                        <template #trigger><i class="pi pi-bars pi-bold"></i></template>
                    </MenuPanel>
                    <wj-menu id="actionMenuId" :displayMemberPath="'titleAction'" :subItemsPath="'attrs'" :showDropDownButton="false"
                        v-else-if="actionMenu.length && !attr?.dropdown"
                        :openOnHover="true" :isAnimated="false" :itemsSource="actionMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
                    >
                        <i class="pi pi-bars pi-bold"></i>
                    </wj-menu>
                </div>
            </div>

            <Codemirror
                :id="attr.html_id"
                v-model:value="content_str"
                v-visible="handleVisibility"
                :options="cmOptions"
                @change="attr_set"
                @ready="editorReady"
            />
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'

import Codemirror from "codemirror-editor-vue3";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/sql/sql.js";
import "codemirror/theme/dracula.css";
import "codemirror/addon/search/searchcursor.js"; // задача 14 ч.1: getSearchCursor для навигации по совпадениям
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/indent-fold";
import "codemirror/addon/fold/comment-fold";
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/theme/neo.css";
import { menuPanelHostMixin } from '@/utils/menuPanelHost'   // IE 2026 09 28 / ODOO-342342: ≡ поля — MenuPanel (как ≡ таблицы), прижат вправо

export default {
    mixins: [menuPanelHostMixin],   // IE 2026 09 28 / ODOO-342342
    props: {
        widget_id: [String, Number],
        attr_id: String,
        initialAttr: {
            type: Object,
            default: null,
        },
        modelValue: { type: String, default: "" },
    },
    emits: ['update:modelValue'],
    data: () => ({
        WIDGET: {},
        content_str: '',
        JS_deep: 3,
        isError: false,
        editMode: false,
        ind_commandPanel: 0,
        cmOptions: {
            mode: {'name': 'javascript', 'json': true}, // Language mode
            // mode: "sql", // Language mode
            theme: "neo", // Theme dracula
            lineNumbers: true, // Show line number
            smartIndent: true, // Smart indent
            indentUnit: 4, // The smart indent unit is 2 spaces in length
            foldGutter: true, // Code folding
            gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
            styleActiveLine: true, // Display the style of the selected row
            // autofocus: true,
            // fontsize: "small",
        },

        commandPanel: [],
        actionMenu: [],
        chips_list: [],
        commandPanelMaxVisible: Infinity,
        commandPanelAreaWidth: null,
        commandPanelMenuWidth: null,
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    mounted() {
        this.WIDGET.attrsResize = this.WIDGET.attrsResize || []
        this.WIDGET.attrsResize.push(this.attrResize)
        // IE 2026 09 25 / ODOO-341407 (проверка dev02 25.09: после живого переключения языка кнопки «Fold: 0 / 1 / 2 / ∞», «JS: 1…» и Save / Cancel
        // панели JSON оставались на прежнем языке): панель собирается строками t() — пересобрать под новый язык (phase 'ui')
        this._i18nHandler = (ev) => {
            if (ev?.detail?.phase !== 'ui') return
            try { this.set_commandPanel() } catch (e) { console.warn('[i18n] json panel', e) }
        }
        window.addEventListener('i18n:changed', this._i18nHandler)
        this.$nextTick(() => {
            const container = this.$refs.commandPanelMenu
            const topLine = this.$refs.attr_top_line
            if (container && topLine && !this.commandPanelResizeObserver) {
                this.commandPanelResizeObserver = new ResizeObserver(() => this.updateCommandPanelOverflow())
                this.commandPanelResizeObserver.observe(topLine)
                const chipsEl = topLine.querySelector('.grid-chips')
                if (chipsEl) this.commandPanelResizeObserver.observe(chipsEl)
            }
            this.updateCommandPanelOverflow()
        })
    },
    beforeUnmount() {
        if (this._i18nHandler) { window.removeEventListener('i18n:changed', this._i18nHandler); this._i18nHandler = null }   // IE 2026 09 25 / ODOO-341407
        this.commandPanelResizeObserver?.disconnect()
        if (this._cpRafId) cancelAnimationFrame(this._cpRafId)
        if (this.WIDGET.attrsResize) {
            const idx = this.WIDGET.attrsResize.indexOf(this.attrResize)
            if (idx !== -1) this.WIDGET.attrsResize.splice(idx, 1)
        }
    },
    methods: {
        content_Changed() {
            let content
            if (this.initialAttr) {
                this.attr = this.initialAttr
                this.WIDGET.attrs_vueObj[this.attr_id] = this
                if (this.attr.dropdown) {
                    this.attr.dropdown.vueObj_content = this
                    content = this.modelValue
                }
            } else {
                this.store.widget_attr_set(this)
                content = this.store.attr_get(this.WIDGET, this.attr) || {}
            }

            this._sourceIsArray = Array.isArray(content)
            this.content_str = this.store.JS_stringify(content, this.JS_deep)
            this.content_str0 = this.content_str
            this.isError = false
            this.set_commandPanel()
            this.$nextTick(() => this.apply_CHIPS())
        },
        attr_set(input) {
            if (this._fromParent) return
            if (!this.editMode) {
                this._editSnapshot = this.content_str0
                this.editMode = true
                this.set_commandPanel()
            }
            this.isError = false
            if (this.content_str === this.content_str0) {
                return
            }
            try {
                let new_content = this.store.JS_parse(this.content_str)
                // if (this._sourceIsArray && !Array.isArray(new_content)) {
                //     new_content = [new_content]
                // }
                this.store.attr_set(this.WIDGET, this.attr, new_content)
            } catch (e) {
                this.isError = true
            }
        },
        attrResize() {
            if (this.attrResize_timeout) { clearTimeout(this.attrResize_timeout) }
            this.attrResize_timeout = window.$cg.setTimeout(this, "AttrJSON.attrResize", () => {
                this.attrResize_afterTimeout()
                this.attrResize_timeout = null
            }, 1)
        },
        attrResize_afterTimeout() {
            if (!this.editor) return
            if (this.attr?.noAutoResize) return
            const elementForm = document.getElementById(`WIDGET${this.widget_id}`)
            if (!elementForm) return
            const wrapperEl = this.editor.getWrapperElement()
            const wrapperRect = wrapperEl.getBoundingClientRect()
            if (wrapperRect.height <= 10) return
            const widgetAttrsEl = elementForm.querySelector('.widget-attrs')
            const containerRect = (widgetAttrsEl || elementForm).getBoundingClientRect()
            let newHeight = Math.floor(containerRect.bottom - wrapperRect.top - 3)
            if (newHeight > containerRect.height) newHeight = 300
            if (newHeight < 80) newHeight = 80
            if (wrapperEl.style.height !== `${newHeight}px`) {
                this.editor.setSize(null, newHeight)
            }
        },
        editorReady(editor) {
            this.editor = editor
            this.attrResize()

            editor.setOption('foldOptions', {
                rangeFinder: CodeMirror.fold.combine(
                    CodeMirror.fold.brace,
                    CodeMirror.fold.indent,
                    CodeMirror.fold.comment,
                ),
                widget: (from, to) => {
                    const count = to.line - from.line
                    const el = document.createElement('span')
                    el.className = 'CodeMirror-foldmarker-1 m-2 pr-1'
                    el.innerHTML = ` ··· ${this.t('{n} ln', { n: count })} <i class="pi dropdown-chevron pi-chevron-down"></i>`   // IE 2026 09 23 / ODOO-341407: i18n
                    el.addEventListener('mousemove', e => e.stopPropagation())
                    return el
                }
            })

            editor.addKeyMap({
                "Esc": (cm) => {
                    cm.getInputField().blur()
                    this.store.runActionForHotKey(this.WIDGET, "Esc")
                },
            });
        },
        unfoldAll() {
            if (!this.editor) return
            const cm = this.editor
            cm.operation(() => {
                for (let i = 0; i < cm.lineCount(); i++) {
                    cm.foldCode(CodeMirror.Pos(i, 0), null, "unfold")
                }
            })
        },
        foldToLevel(maxLevel) {
            if (!this.editor) return
            const cm = this.editor
            const rangeFinder = cm.getOption('foldOptions')?.rangeFinder || CodeMirror.fold.auto

            cm.operation(() => {
                for (let i = 0; i < cm.lineCount(); i++) {
                    cm.foldCode(CodeMirror.Pos(i, 0), null, "unfold")
                }

                const foldRanges = []
                for (let i = 0; i < cm.lineCount(); i++) {
                    const range = rangeFinder(cm, CodeMirror.Pos(i, 0))
                    if (range) {
                        foldRanges.push({ line: i, from: range.from, to: range.to })
                    }
                }

                for (const r of foldRanges) {
                    r.depth = 0
                    for (const parent of foldRanges) {
                        if (parent === r) continue
                        if (parent.from.line < r.from.line && parent.to.line >= r.to.line) {
                            r.depth++
                        }
                    }
                }

                foldRanges.sort((a, b) => b.depth - a.depth)
                for (const r of foldRanges) {
                    if (r.depth >= maxLevel) {
                        const marks = cm.findMarksAt(CodeMirror.Pos(r.line, 0))
                        if (marks.some(m => m.collapsed)) continue
                        cm.foldCode(CodeMirror.Pos(r.line, 0), null, "fold")
                    }
                }
            })
        },
        handleVisibility(isVisible) {
            this.isVisible = isVisible
            if (isVisible && this.editor) {
                this.editor.refresh()
                this.attrResize()
            }
        },
        set_commandPanel() {
            const commandPanel = []
            const eval_params = { attr: this.attr }
            const source_name = this.attr_id

            // IE 2026 09 23 / ODOO-341407: i18n: подписи кнопок панели и меню
            commandPanel.push({
                'attr_type': 'AttrButton', source_name, 'binding': this.attr.binding,
                'active': this.editMode, 'title': this.t('Edit JSON'), 'command': 'onAttrJSON_toggleEdit__Click',
                'cssClass': 'pi p-button-white pi-pencil',
                isDropdown: !!(this.attr.dropdown),
            })
            if (this.editMode) {
                commandPanel.push({
                    'attr_type': 'AttrButton', source_name, 'binding': this.attr.binding,
                    'title': this.t('Apply'), 'command': 'onAttrJSON_apply__Click',
                    'cssClass': 'pi p-button-white pi-check',
                    isDropdown: !!(this.attr.dropdown),
                })
                commandPanel.push({
                    'attr_type': 'AttrButton', source_name, 'binding': this.attr.binding,
                    'title': this.t('Cancel'), 'command': 'onAttrJSON_cancel__Click',
                    'cssClass': 'pi p-button-white pi-times',
                    isDropdown: !!(this.attr.dropdown),
                })
            }

            if (!this.attr?.dropdown) {
                commandPanel.push({ autoGeneratedButton: true })
                for (const fold_deep of [0, 1, 2, Infinity]) {
                    const label = fold_deep === Infinity ? '∞' : String(fold_deep)
                    commandPanel.push({
                        'attr_type': 'AttrButton', source_name, 'binding': this.attr.binding,
                        'title': fold_deep === 0 ? this.t('Fold: {n}', { n: label }) : label,
                        'command': 'onFold_deep__Click', 'params': { fold_deep },
                        'cssClass': 'pi p-button-white p-2', 'showCommandTitle': true,
                    })
                }
                commandPanel.push({ autoGeneratedButton: true })
                for (const js_deep of [1, 2, 3, 4, 5]) {
                    commandPanel.push({
                        'attr_type': 'AttrButton', source_name, 'binding': this.attr.binding,
                        'active': this.JS_deep === js_deep,
                        'title': js_deep === 1 ? this.t('JS: {n}', { n: js_deep }) : String(js_deep),
                        'command': 'onJS_deep__Click', 'params': { JS_deep: js_deep },
                        'cssClass': 'pi p-button-white p-2', 'showCommandTitle': true,
                    })
                }
            }

            let need_separator = commandPanel.length
            if (this.attr?.groupMenu?.commandPanel) {
                this.attr.groupMenu.commandPanel.forEach(attrButton => {
                    const v_if = attrButton['v-if']
                    if (!attrButton.autoGeneratedButton) {
                        const visible_ = this.store.eval_value(this.WIDGET, v_if, eval_params)
                        if (attrButton.visible != visible_) {
                            attrButton.visible = visible_
                        }
                        if (need_separator) {
                            commandPanel.push({ autoGeneratedButton: true })
                            need_separator = false
                        }
                        commandPanel.push(attrButton)
                    }
                })
            }

            this.store.prepare_attrs(commandPanel, (this.attr.html_id || this.attr.id || 'json') + (++this.ind_commandPanel))
            this.commandPanel = commandPanel

            this.actionMenu = this.store.actionMenu_from_commandPanel(commandPanel)

            const action = [
                { 'attr_type':'AttrTab', 'title': this.t('Fold'), 'attrs': [
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: 0 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':0} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: 1 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':1} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: 2 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':2} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: 3 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':3} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: 4 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':4} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: 5 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':5} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: 6 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':6} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: 7 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':7} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('Fold: {n}', { n: '∞' }), 'command': 'onFold_deep__Click', 'params':{'fold_deep': Infinity} },
                ]},
                { 'attr_type':'AttrTab', 'title': this.t('JS deep'), 'attrs': [
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('JS deep: {n}', { n: 0 }), 'command': 'onJS_deep__Click', 'params':{'JS_deep':0} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('JS deep: {n}', { n: 1 }), 'command': 'onJS_deep__Click', 'params':{'JS_deep':1} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('JS deep: {n}', { n: 2 }), 'command': 'onJS_deep__Click', 'params':{'JS_deep':2} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('JS deep: {n}', { n: 3 }), 'command': 'onJS_deep__Click', 'params':{'JS_deep':3} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('JS deep: {n}', { n: 4 }), 'command': 'onJS_deep__Click', 'params':{'JS_deep':4} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('JS deep: {n}', { n: 5 }), 'command': 'onJS_deep__Click', 'params':{'JS_deep':5} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('JS deep: {n}', { n: 6 }), 'command': 'onJS_deep__Click', 'params':{'JS_deep':6} },
                    { 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'title': this.t('JS deep: {n}', { n: 7 }), 'command': 'onJS_deep__Click', 'params':{'JS_deep':7} },
                ]},
            ]
            for (const command of action) {
                this.actionMenu.push(this.store.prepare_actionMenu(command))
            }

            // this.actionMenu.push(this.store.prepare_actionMenu({ 'title': '-' }))
            // this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-excel', 'title': 'Export (XLSX)', 'command': 'copyPaste', method: 'exportGrid', 'params':{'format':'xlsx'}, source_name:this.attr.name, 'binding':this.attr.binding }))
            // this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-pdf', 'title': 'Export (PDF)', 'command': 'copyPaste', method: 'exportGrid', 'params':{'format':'pdf'}, source_name:this.attr.name, 'binding':this.attr.binding }))
            // this.actionMenu.push(this.store.prepare_actionMenu({ 'title': '-' }))
            // this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-export', 'title': 'Export (JSON)', 'command': 'copyPaste', method: 'exportItems', 'params':{'format':'json'}, source_name:this.attr.name, 'binding':this.attr.binding }))
            // this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-import', 'title': 'Import (JSON)', 'command': 'copyPaste', method: 'importItems', 'params':{'format':'json'}, source_name:this.attr.name, 'binding':this.attr.binding }))

            this._cpItemWidths = null
            this.commandPanelMaxVisible = Infinity
            this.commandPanelAreaWidth = null
            this.commandPanelMenuWidth = null
            this.$nextTick(() => {
                const container = this.$refs.commandPanelMenu
                const topLine = this.$refs.attr_top_line
                if (!container || !topLine) return
                if (!this.commandPanelResizeObserver) {
                    this.commandPanelResizeObserver = new ResizeObserver(() => this.updateCommandPanelOverflow())
                }
                this.commandPanelResizeObserver.observe(topLine)
                const chipsEl = topLine.querySelector('.grid-chips')
                if (chipsEl) this.commandPanelResizeObserver.observe(chipsEl)
                this.updateCommandPanelOverflow()
            })
        },
        onChipsUpdate(chips) {
            this.chips_list = chips
            this.apply_CHIPS()
        },
        apply_CHIPS() {
            if (!this.editor) return
            const searchChips = this.chips_list.filter(c => c.use !== false && c.segment === 'CHIP-Search')
            this._applyChipsOverlay(searchChips)
            const cm = this.editor
            const cursor = cm.getCursor('from')
            cm.operation(() => {
                for (let i = 0; i < cm.lineCount(); i++) {
                    cm.removeLineClass(i, 'wrap', 'cm-line-filtered-out')
                }
                if (!searchChips.length) return
                // ч.2: чекбокс «показать строки без найденных» — подсветку оставляем,
                // строки без совпадений не скрываем
                if (searchChips.some(c => c.showAllLines)) return
                for (let i = 0; i < cm.lineCount(); i++) {
                    const lineText = cm.getLine(i).toLowerCase()
                    const matches = searchChips.some(chip => lineText.includes(chip.title.toLowerCase()))
                    if (!matches) {
                        cm.addLineClass(i, 'wrap', 'cm-line-filtered-out')
                    }
                }
            })
            if (searchChips.length) {
                this._scrollToChipMatch(cm, cursor.line, searchChips)
            } else {
                // фильтр снят (удалён последний search-чипс): вернуть выделенную строку
                // в видимую область — иначе после разворота она уезжает за viewport (задача 14)
                requestAnimationFrame(() => cm.scrollIntoView({ line: cursor.line, ch: cursor.ch || 0 }))
            }
            this._recomputeSearchNav(cm, searchChips)
        },
        _recomputeSearchNav(cm, searchChips) {
            // задача 14 ч.1: позиции всех совпадений (регистронезависимо; '=' не ищем) →
            // счётчик matchCount/matchIndex на search-чипсы (читает AttrChips)
            const list = []
            for (const chip of searchChips) {
                const term = String(chip.title || '')
                if (!term || term.startsWith('=')) continue
                const cur = cm.getSearchCursor(term, { line: 0, ch: 0 }, { caseFold: true })
                while (cur.findNext()) list.push({ from: cur.from(), to: cur.to() })
            }
            list.sort((a, b) => a.from.line - b.from.line || a.from.ch - b.from.ch)
            const idx = Math.min(this._searchNav?.index || 0, Math.max(0, list.length - 1))
            this._searchNav = { list, index: idx }
            for (const chip of searchChips) { chip.matchCount = list.length; chip.matchIndex = list.length ? idx : 0 }
            this.$refs.chips?.$forceUpdate()
        },
        onChipSearchNav({ dir }) {
            const nav = this._searchNav
            if (!nav || !nav.list.length) return
            nav.index = (nav.index + dir + nav.list.length) % nav.list.length
            const m = nav.list[nav.index]
            const cm = this.editor
            cm.setSelection(m.from, m.to)
            cm.scrollIntoView({ from: m.from, to: m.to }, 60)
            cm.focus()
            const searchChips = this.chips_list.filter(c => c.use !== false && c.segment === 'CHIP-Search')
            for (const chip of searchChips) chip.matchIndex = nav.index
            this.$refs.chips?.$forceUpdate()
        },
        _scrollToChipMatch(cm, fromLine, searchChips) {
            const lineMatches = (i) => {
                const text = cm.getLine(i)?.toLowerCase() || ''
                return searchChips.some(c => text.includes(c.title.toLowerCase()))
            }
            let target = fromLine
            if (!lineMatches(target)) {
                let found = false
                for (let i = fromLine - 1; i >= 0 && !found; i--) {
                    if (lineMatches(i)) { target = i; found = true }
                }
                if (!found) {
                    for (let i = fromLine + 1; i < cm.lineCount(); i++) {
                        if (lineMatches(i)) { target = i; break }
                    }
                }
            }
            requestAnimationFrame(() => cm.scrollIntoView({ line: target, ch: 0 }))
        },
        _applyChipsOverlay(searchChips) {
            const cm = this.editor
            if (this._chipsOverlay) {
                cm.removeOverlay(this._chipsOverlay)
                this._chipsOverlay = null
            }
            if (!searchChips.length) return
            const terms = searchChips.map(c => c.title.toLowerCase())
            this._chipsOverlay = {
                token(stream) {
                    for (const term of terms) {
                        if (stream.match(term, true, true)) return 'chip-search-match'
                    }
                    stream.next()
                    return null
                }
            }
            cm.addOverlay(this._chipsOverlay)
        },
        updateCommandPanelOverflow() {
            if (this._cpRafId) cancelAnimationFrame(this._cpRafId)
            this._cpRafId = requestAnimationFrame(() => {
                this._cpRafId = null
                const cpArea = this.$refs.commandPanelArea
                const topLine = this.$refs.attr_top_line
                if (!cpArea || !topLine) return
                if (topLine.clientWidth <= 10) return
                let itemWidths = this._cpItemWidths
                if (!itemWidths?.length || itemWidths.every(w => w === 0)) {
                    const container = this.$refs.commandPanelMenu
                    itemWidths = container ? Array.from(container.children).map(el => el.offsetWidth) : []
                    if (!itemWidths.length || itemWidths.every(w => w === 0)) return
                    this._cpItemWidths = itemWidths
                }
                const chipsEl = topLine.querySelector('.grid-chips')
                let chipsDesiredWidth = 0
                if (chipsEl) {
                    chipsDesiredWidth = 130
                    const inputContainer = chipsEl.querySelector('.input-container')
                    if (inputContainer) {
                        const children = Array.from(inputContainer.children)
                        const sumW = children.reduce((s, el) => s + el.offsetWidth, 0)
                        chipsDesiredWidth = Math.max(sumW + Math.max(children.length - 1, 0) * 4 + 8, 130)
                    }
                }
                const chipsCurrentWidth = chipsEl?.clientWidth ?? 0
                const available = Math.max(cpArea.clientWidth + chipsCurrentWidth - chipsDesiredWidth, 0)
                let total = 0
                let maxVisible = itemWidths.length
                for (let i = 0; i < itemWidths.length; i++) {
                    total += itemWidths[i]
                    if (total > available) { maxVisible = i; break }
                }
                let overflowBtnWidth = 0
                if (maxVisible < itemWidths.length) {
                    const overflowBtnEl = cpArea.querySelector('.commandPanel-overflow-btn')
                    overflowBtnWidth = overflowBtnEl ? overflowBtnEl.offsetWidth : 28
                    const availableForItems = Math.max(available - overflowBtnWidth, 0)
                    total = 0
                    maxVisible = itemWidths.length
                    for (let i = 0; i < itemWidths.length; i++) {
                        total += itemWidths[i]
                        if (total > availableForItems) { maxVisible = i; break }
                    }
                }
                if (this.commandPanelMaxVisible !== maxVisible) this.commandPanelMaxVisible = maxVisible
                let visibleItemsWidth = itemWidths.slice(0, maxVisible).reduce((a, b) => a + b, 0)
                let visibleWidth = visibleItemsWidth + overflowBtnWidth
                if (!this.commandPanelOverflow.length) { visibleItemsWidth += 10; visibleWidth += 10 }
                if (this.commandPanelMenuWidth !== visibleItemsWidth) this.commandPanelMenuWidth = visibleItemsWidth
                if (this.commandPanelAreaWidth !== visibleWidth) this.commandPanelAreaWidth = visibleWidth
            })
        },
        menuNodeClicked(menu) {
            this.menuAction(menu.itemsSource[menu.selectedIndex])   // IE 2026 09 28 / ODOO-342342: выбор пункта wj-menu и MenuPanel (menuPanelPick) — одно действие
        },
        menuAction(action) {   // IE 2026 09 28 / ODOO-342342: прежнее тело menuNodeClicked
            if (action?.command === 'onFold_deep__Click') {
                const level = action.params?.fold_deep
                if (level === Infinity) {
                    this.unfoldAll()
                } else {
                    this.foldToLevel(level)
                }
                return
            }
            if (action?.command === 'onJS_deep__Click') {
                this.JS_deep = action.params?.JS_deep
                this.content_Changed()
                return
            }
            const vueObj = this.WIDGET.vueObj
            this.store.executeStoreMethod(vueObj, action)
        },
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(v) {
                const next = typeof v === 'string' ? v : this.store.JS_stringify(v ?? {}, this.JS_deep)
                if (next === this.content_str) return;
                this._fromParent = true;
                this.content_str = next;
                this.isError = false
                this.$nextTick(() => {
                    this._fromParent = false;
                });
            },
        },
    },
    computed: {
        commandPanelOverflow() {
            if (this.commandPanelMaxVisible >= this.commandPanel.length) return []
            return this.commandPanel
                .slice(this.commandPanelMaxVisible)
                .filter(item => item.attr_type !== 'AttrSeparator' && item.visible !== false)
        },
    },
    components: {
      Codemirror,
    },
}
</script>

<style>
.cm-s-neo .CodeMirror-linenumber {
    color: #999;
}
.CodeMirror-foldmarker-1 {
    font-stretch: ultra-condensed;
    color: white;
    font-family: arial;
    background: #8ea0ff;
    border-radius: 3px;
    cursor: pointer !important;
}
</style>

<style>
.json-top-line {
    position: sticky;
    top: 0;
    z-index: 10;
    background: white;
    flex-shrink: 0;
    opacity: 1;
}
.attr-json .codemirror-container {
    margin-top: 4px;
}
</style>

<style scoped>
.json-error {
    position: absolute;
    left: 100px;
    top: 1px;

    z-index: 99;
    background-color: #fff4e5;
    border: 1px solid #f5c06a;
    color: #a65e00;           
    padding: 10px 16px;
    margin-bottom: 12px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    gap: 6px;
}
</style>